<template>
  <div>
    <div class="test-content">
      <ul>
        <JudgeLi v-for="(pep,index) in arr" :content="pep" :type="1":key="index" v-on:listenToChildEvent="showMsg"></JudgeLi>
      </ul>
      <div class="numShow">
        <span class="progress-text">得分<span class="right-text">{{rightScore}}</span></span>
        <div class="progress-back">
          <div class="progress-font" :style="widthStyle"></div>
        </div>
      </div>
      <div class="modal-box" v-if="modalshow">
        <div class="modal-content">
          <p class="modal-title">你已完成20题，可以选择继续或结束闯关</P>
          <p>接下来，请选择</p>
          <button class="default-btn primary-btn" @click="continueBack">继续做题，挑战自己</button>
          <button class="default-btn end-btn" @click="saveCosGraduateAnswer" v-preventReClick>闯关结束</button>
        </div>
      </div>
    </div>
    <div class="button-box" v-if="next">
      <button class="default-btn large-btn end-btn" @click="continueNext">知道了，继续</button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
	import JudgeLi from '../components/JudgeLi';
  import axios from 'axios';
  import qs from 'qs';
  import setWechatTitle from '@/utils/setWechatTitle.js'
  export default {
    props: {
      id: Number
    },
    name: 'Competence',
    components: {
      'JudgeLi': JudgeLi
    },
    data() {
      return {
        next:false,
        arr: [{
            'num': 1,
            'order': '1/44',
            'title': '各级机关考录公务员、事业单位招聘工作人员时，免收困难家庭高校毕业生的报名费和体检费。其中困难家庭高校毕业生类型不包括以下哪种：',
            'answer': ['A．城镇低保家庭','B．低保边缘户家庭','C．农村贫困家庭','D．单亲家庭'],
            'rightAnswer': 'D',
            'show': true,
          },
          {
            'num': 2,
            'order': '2/44',
            'title': '根据2024年实施的高校毕业生就业服务攻坚行动，人社部将组织百万毕业生参加见习，以丰富实践经验，提升就业能力和市场竞争能力。对企业开放见习岗位的，给予____个月的政策补贴。',
            'answer': ['A．1-3','B．3-6','C．6-12','D．12-24'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 3,
            'order': '3/44',
            'title': '2020年，国家对建档立卡贫困家庭和____的毕业生实行“一对一”帮扶，政策服务全兜底。',
            'answer': ['A．零劳动能力','B．零就业家庭','C．零技能','D．零渠道'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 4,
            'order': '4/44',
            'title': '中央组织部、人事部、教育部、财政部等八个部门联合组织“三支一扶”，从2006开始，每年招募高校毕业生到乡镇基层开展“三支一扶”工作，其中以下哪项不是“三支一扶”的内容？',
            'answer': ['A．支农','B．支医','C．扶贫','D．支法'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 5,
            'order': '5/44',
            'title': '“三支一扶”的工作年限一般为几年？',
            'answer': ['A．1年','B．2年','C．3年','D．4年'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 6,
            'order': '6/44',
            'title': '相关事业单位公开招聘工作人员，应拿出不低于多少的比例，聘用具有两年以上基层工作经历的高校毕业生，在同等条件下要优先聘用“三支一扶”大学生。',
            'answer': ['A．20%','B．30%','C．35%','D．40%'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 7,
            'order': '7/44',
            'title': '“三支一扶”的招募对象是有条件要求的，以下哪个条件不符合报名要求？',
            'answer': ['A．已签订就业协议但未入职毕业生','B．毕业2年内未就业的往届毕业生','C．学历要为大专以上','D．应届毕业生'],
            'rightAnswer': 'A',
            'show': false
          },
          {
            'num': 8,
            'order': '8/44',
            'title': '以下哪个不符合农村教师特岗计划招聘的对象和条件？',
            'answer': ['A．全日制普通高等应届本科毕业生','B．应届师范类专业专科毕业生','C．有半年以上支教经验的师范院校毕业生','D．年龄可超过30岁'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 9,
            'order': '9/44',
            'title': '农村特岗教师的聘用期限是几年？',
            'answer': ['A．1年','B．2年','C．3年','D．4年'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 10,
            'order': '10/44',
            'title': '农村特岗教师计划在几月份启动招聘工作？',
            'answer': ['A．3月','B．4月','C．5月','D．6月'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 11,
            'order': '11/44',
            'title': '少数民族学生、省级优秀毕业生、省级及以上三好学生、校级三好学生在报考农村教师特岗计划时，可在面试成绩中给予适当加分，可以累计加分，但最高得分不得超过几分？',
            'answer': ['A．4分','B．5分','C．6分','D．7分'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 12,
            'order': '12/44',
            'title': '选聘高校毕业生到农村可担任的职务，不包括以下哪种？',
            'answer': ['A．村长','B．村党支部书记助理','C．村委会主任助理','D．副书记'],
            'rightAnswer': 'A',
            'show': false
          },
          {
            'num': 13,
            'order': '13/44',
            'title': '选聘高校毕业生到村任职的工作期限一般为几年？',
            'answer': ['A．1-2年','B．2-3年','C．3-4年','D．5年'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 14,
            'order': '14/44',
            'title': '到村任职____年以上，具备“选调生”条件和资格的，经组织推荐，可参加选调生统一招考。',
            'answer': ['A．1','B．2','C．3','D．5'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 15,
            'order': '15/44',
            'title': ' 对选聘到村任职的高校毕业生，中央财政发放一次性安置费的人均补贴标准是？',
            'answer': ['A．1000元','B．1500元','C．2000元','D．2500元'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 16,
            'order': '16/44',
            'title': '国家鼓励高校毕业生入伍，并对应征入伍服义务兵役的学生给予国家资助，以下哪种类型的学生不享受国家资助？',
            'answer': ['A．往届毕业生','B．全日制普通本科生','C．专科生（含高职）','D．定向生、委培生和国防生'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 17,
            'order': '17/44',
            'title': '应征入伍毕业生享受学费补偿、国家助学贷款代偿及学费减免政策，对于每人每年补助的标准，以下错误的是？',
            'answer': ['A．专科生不超过4000元','B．本科生不超过6000元','C．硕士研究生不超过8000元','D．博士研究生不超过10000元'],
            'rightAnswer': 'A',
            'show': false
          },
          {
            'num': 18,
            'order': '18/44',
            'title': ' 以下是报名应征入伍服兵役的四个在校大学生，哪个不符合要求？',
            'answer': ['A．17岁','B．18岁','C．22岁','D. 25岁'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 19,
            'order': '19/44',
            'title': '以下关于大学生士兵退役后可享受的就学优惠政策，不包括的是？',
            'answer': ['A．高职（专科）学生的入伍经历可作为毕业实习经历','B．本科毕业三年内考研初试加10分','C．退役后可获得户籍省会所在地的城镇户口','D．荣立二等功及以上的退役人员可免初试攻读硕士研究生'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 20,
            'order': '20/44',
            'title': '大学生志愿服务西部计划从2003年开始实施，按照公开招募、自愿报名、组织选拔、集中派遣的方式，每年招募一定数量的普通高等学校应届毕业生或在读研究生，到西部基层开展为期____年的教育、卫生、农技、扶贫等志愿服务。',
            'answer': ['A．1','B．1-3','C．3-4','D．5'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 21,
            'order': '21/44',
            'title': '大学生志愿服务西部计划的内容包括基础教育、服务三农、医疗卫生、基层青年工作、基层社会管理、服务新疆和____7个专项。',
            'answer': ['A．服务贵州','B．服务甘肃','C．服务西藏','D．服务宁夏'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 22,
            'order': '22/44',
            'title': '参加西部计划项目前无工作经历的志愿者服务期满且考核合格后____年内（研究生支教团志愿者自研究生毕业时开始计算），在参加机关事业单位考录（招聘）、各类企业吸纳就业、自主创业、落户、升学等方面可同等享受应届高校毕业生的相关政策。',
            'answer': ['A．2','B．3','C．4','D．5'],
            'rightAnswer': 'A',
            'show': false
          },
          {
            'num': 23,
            'order': '23/44',
            'title': '参加西部计划，服务____年以上且考核合格的，服务期满后3年内报考硕士研究生的，初试总分加10分，同等条件下优先录取。',
            'answer': ['A．1','B．2','C．3','D．4'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 24,
            'order': '24/44',
            'title': '高校毕业生自主创业，可以享受哪些优惠政策？',
            'answer': ['A．小额担保贷款和贴息支持','B．免收有关行政事业性收费','C．享受培训补贴','D．免费购买设备等基础设施'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 25,
            'order': '25/44',
            'title': '对于有关微利项目的创业，贷款利息由财政承担50%，其中以下哪些不属于微利项目？',
            'answer': ['A．修理修配','B．残疾儿童教育训练和寄托服务','C．旅行社服务 ','D．养老服务'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 26,
            'order': '26/44',
            'title': '小额担保贷款的期限一般不超过几年？',
            'answer': ['A．1年','B．2年','C．3年 ','D．4年'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 27,
            'order': '27/44',
            'title': '政府人事行政部门所属的人才中介服务机构，免费为自主创业毕业生保管人事档案（包括代办社保、职称、档案工资等有关手续）几年？',
            'answer': ['A．1年','B．2年','C．3年 ','D．4年'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 28,
            'order': '28/44',
            'title': '大学毕业生新办从事公用事业、商业、物资业、对外贸易业、旅游业、物流业、仓储业、居民服务业、饮食业、教育文化事业、卫生事业的企业或经营单位，经税务部门批准，免征企业所得税几年？',
            'answer': ['A．1年','B．2年','C．3年 ','D．4年'],
            'rightAnswer': 'A',
            'show': false
          },
          {
            'num': 29,
            'order': '29/44',
            'title': '以下哪个不属于联合国的国际公务员的类型？',
            'answer': ['A．P：专业人员','B．G：一般事务人员','C．D：高级管理人员 ','D．M：市场人员'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 30,
            'order': '30/44',
            'title': '对于想加入联合国的高校毕业生而言，最常规的方式，是参加联合国的____考试。',
            'answer': ["A．青年专业人员（YPP）","B．美国研究生入学考试（GRE）","C．思维能力评估（TS'A）","D．托福（TOEFL）"],
            'rightAnswer': 'A',
            'show': false
          },
          {
            'num': 31,
            'order': '31/44',
            'title': '对于到国际组织实习的学生，毕业生可向学校申请保留户口档案____年。',
            'answer': ['A．1','B．2','C．3','D. 4'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 32,
            'order': '32/44',
            'title': '国家对留学基金管理委员会对符合条件的到国际组织实习的高校学生予以资助，包括一次性往返国际旅游、资助期限内的奖学金和艰苦地区补贴，资助期限为____个月。',
            'answer': ['A．1-3','B．3-12','C．12-16','D．16-18'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 33,
            'order': '33/44',
            'title': '杭州市为引进人才,对来杭工作的全球本科对来杭工作的全球本科及以上学历应届毕业生（含毕业5年内的回国留学人员、外国人才）发放一次性生活补贴，其中本科__万元、硕士__万元、博士__万元。',
            'answer': ['A．0.5、1、2','B．1、1.5、2','C．1、3、5 ','D．1.5、3、4'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 34,
            'order': '34/44',
            'title': '杭州《关于进一步优化户籍管理服务营商环境的通知》中提到，年龄   周岁以下的全日制普通高校大专（含高职）学历，在杭工作并由用人单位正常缴纳社保的，可申请办理落户，不受紧缺专业及居住登记条件的限制。',
            'answer': ['A．30','B．35','C．40 ','D．44'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 35,
            'order': '35/44',
            'title': '在长沙工作、具有____以上学历或技师以上职业资格的人才，首套房不受户籍和个税、社保缴存限制。',
            'answer': ['A．专科','B．本科','C．硕士 ','D．博士'],
            'rightAnswer': 'A',
            'show': false
          },
          {
            'num': 36,
            'order': '36/44',
            'title': ' 在西安，近____年毕业或35周岁以下的高校毕业生创业，可申请贷款，额度最高50万元，期限一般为2年，并给予50%贴息。',
            'answer': ['A．3','B．4','C．5 ','D．6'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 37,
            'order': '37/44',
            'title': '应届毕业生在西安就业落户，签订劳动合同，并交纳社会保险的，给予____元一次性奖励补助，并发放西纳英才、安心乐业大礼包。',
            'answer': ['A．500','B．800','C．1000 ','D．1200'],
            'rightAnswer': 'C',
            'show': false
          },
          {
            'num': 38,
            'order': '38/44',
            'title': '湖北武汉市发布的《关于进一步放宽留汉大学毕业生落户试行政策的通知》，通知明确，留汉大学毕业生年龄不满____周岁的，可凭毕业证申请登记为武汉市常住户口，硕士研究生、博士研究生不受年龄限制。',
            'answer': ['A．30','B．35','C．38','D．40'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 39,
            'order': '39/44',
            'title': '成都市出台的“蓉漂”计划则打出“先落户后就业”的口号。按照这一政策，具有全日制大学本科及以上学历的青年人才，以及在同一用人单位工作____年及以上的技能人才，均可申请办理落户手续。',
            'answer': ['A．1','B．2','C．3','D．4'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 40,
            'order': '40/44',
            'title': '2020年南京发布10条新政促高校毕业生在南京就业创业，其中放宽落户门槛，其中本科学历人才从40周岁放宽到44周岁，将留学回国人员和非全日制研究生一并纳入，40周岁以下大专学历人员，在南京就业参保____年就可以落户。',
            'answer': ['A．0.5','B．1','C．2','D．3'],
            'rightAnswer': 'A',
            'show': false
          },
          {
            'num': 41,
            'order': '41/44',
            'title': '在青岛高校在校生、国内（境）外高校专科及以上毕业学年在校生可申请在青岛落户，落户后，可享受本市购房政策。对符合条件的毕业生，分别按照本科、硕士和博士每月500元、1200元和1500元的补贴标准，给予最长不超过____个月的住房补贴。',
            'answer': ['A．12','B．18','C．24','D．36'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 42,
            'order': '42/44',
            'title': '在安徽，校毕业生与小微企业签订____个月以上劳动合同，并依法缴纳社会保险费的，安徽将给予毕业生每人3000元的一次性就业补贴。高校毕业生创业可申请最高不超过15万元的创业担保贷款，贷款期限为____年，按规定财政给予贴息。',
            'answer': ['A．6、2','B．6、3','C．12、2','D．12、3'],
            'rightAnswer': 'B',
            'show': false
          },
          {
            'num': 43,
            'order': '43/44',
            'title': '哪些高校毕业生可以被吸纳为国家和地方重大科研项目的研究助理或辅助人员？',
            'answer': ['A．本科生','B．硕士研究生','C．博士研究生','D．以上都是'],
            'rightAnswer': 'D',
            'show': false
          },
          {
            'num': 44,
            'order': '44/44',
            'title': '以下哪个不属于近几年国家鼓励和引导高校毕业生去就业创业的重要领域？',
            'answer': ['A．一带一路建设','B．京津冀协同发展','C．长江经济带发展','D．北上广深'],
            'rightAnswer': 'D',
            'show': false
          }
        ],
        data: '', //已做题目的答案
        rightNum: 0, //答对题数
        rightScore:0,
        numShow: false, //控制答题进度的显示
        show: false, //控制闯关结束的显示
        modalshow: false, //控制15题模态框的显示
        widthStyle: {
          width: ''
        },
        current:0,
        submitNum:0
      }
    },
    computed: {
      ...mapState({
        shengyaUser: state => state.shengyaUser.userInfo,
      }),
    },
    created(){
      setWechatTitle('生涯驿站-毕业政策探索');
    },
    methods: {
      saveCosGraduateAnswer(){
        if(this.submitNum==0){
          this.submitNum=1
          const options = {
            method: 'POST',
            headers: {
              'content-type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify({
              submitdata: this.data,
              openId: this.shengyaUser.openid
            }),
            url: '/cob/saveCosGraduateAnswer.do'
          };
          axios(options)
            .then((response)=>{
              if(response.data.result.success){
                let cosAnswer = response.data
                let shengyaUser = cosAnswer.data.user
                this.$bus.$emit('play-finish', shengyaUser)
              }
            })
            .catch((error)=>{
              console.log(error);
            });
        }
      },
      // 保存本题所选答案，如果答对加分，答错不计分
      showMsg(res, cur){
        const progress = document.getElementsByClassName('progress-font');
        const right_answer = this.arr[cur - 1].rightAnswer;
        this.current = cur
        // 保存每一题的答案
        this.data += cur + "$" + res
        if (cur < 44) {
          this.data += "}"
        }
        if (res == right_answer) {
          setTimeout(this.showNext(),2000)
          this.rightNum++;
          if(this.rightNum<44){
            this.rightScore = parseInt(this.rightNum*2.27);
          }else{
            this.rightScore = 100;
          }
          this.widthStyle.width = (this.rightNum * 2.27) + '%';
        }else{
          this.next = true
        }
        if(cur == 20){
           this.modalshow = true
        }else if(cur == 44) {
          this.saveCosGraduateAnswer()
        }
      },
      continueNext(){
        this.showNext()
        this.next = false
      },
      continueBack(){
        this.modalshow = false;
      },
      showNext(){
        this.arr.map((item)=>{
          // 判断答案正确，显示下一题
          if(item.show){
            item.show=false
          }
          if (item.num == (this.current + 1)) {
            item.show=true
            return true
          }
        })
      },
      continueBack(){
        this.modalshow = false;
      }
    }
  }
</script>
<style lang="stylus" scoped>
.progress-back
  background-color:rgba(42,116,181,0.51)
</style>
